import saveFilter from "./saveFilter";

export { saveFilter };

export default { saveFilter };